import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Row, Col} from 'reactstrap';

class MagstimHistoryFields extends React.Component {

    render() {

        return (
            <Wrapper>
                {
                    Object.keys(this.props.listitems).map(function(key, index) {

                        var label;
                        if (undefined !== this.props.listitems[index].color) {
                            label = <label style={{color: this.props.listitems[index].color}}>{this.props.listitems[index].name}</label>;
                        }
                        else {
                            label = <label>{this.props.listitems[index].name}</label>;
                        }

                        const columnName = <Col data-testid="data-table-name" xs={this.props.col1Size}>{label}</Col>; 
                        const columValue = <Col data-testid="data-table-value" xs={this.props.col2Size} className="value-text" >{this.props.listitems[index].value}</Col>;

                        if (undefined !== this.props.listitems[index].backgroundColor) {
                            return <Row key={'Row-' + key + '-' + index} style={{ backgroundColor: this.props.listitems[index].backgroundColor, color: this.props.listitems[index].color}} >
                                {columnName}{columValue}
                            </Row>;
                        }
                        else {
                            return <Row key={'Row-' + key + '-' + index}>
                                {columnName}{columValue}
                            </Row>;
                        }

                    }.bind(this)
                    )
                }
            </Wrapper>
        );
    }
}

MagstimHistoryFields.propTypes = {
    listitems: PropTypes.array,
    col1Size: PropTypes.number,
    col2Size: PropTypes.number
};

MagstimHistoryFields.defaultProps = {
    listitems: [],
    col1Size: 7,
    col2Size: 5
};

const Wrapper = styled.div`
.value-text{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    -webkit-box-orient: vertical;
}
`;

export default MagstimHistoryFields;